import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, reactive, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

import { required, sameAs } from '@vuelidate/validators';

import { checkResetUserPasswordToken } from '@/entities/user/services';
import { useResetUserPasswordMutation } from '@/entities/user/hooks';
import { passwordRegex as passwordRule } from '@/utils/vuelidate-custom';

import {
  NkForm,
  NkContainer,
  NkStack,
  NkFormItem,
  NkInputText,
  NkHeading,
  NkCenter,
  NkButton,
  NkPasswordError,
} from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkResetPassword',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const token = computed(() => (route.params.token as string));

const form = ref();


const fields = reactive({
  password: '',
  passwordConfirmation: '',
});

const { password } = toRefs(fields);

const rules = computed(() => ({
  password: {
    required,
    passwordRule,
  },
  passwordConfirmation: {
    sameAs: sameAs(password),
  },
}));

const { mutateAsync, isLoading, error, isError } = useResetUserPasswordMutation();

const handleSubmit = () => {
  form.value.validator.$validate().then((valid: boolean) => {
    if (valid) {
      mutateAsync({
        token: token.value,
        ...fields,
      }).then(() => {
        router.push({
          name: 'security-login',
          params: {
            flashMessage: JSON.stringify({
              type: 'success',
              message: t('user.form.notification.reset_password.success'),
            }),
          },
        });
      });
    }
  });
};

onMounted(() => {
  checkResetUserPasswordToken({ token: token.value }).then(({ validToken }) => {
    if (!validToken) {
      router.push({
        name: 'security-login',
        params: {
          flashMessage: JSON.stringify({
            type: 'error',
            message: t('user.form.notification.reset_password_token_check_failure'),
          }),
        },
      });
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_ElAlert = _resolveComponent("ElAlert")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkContainer), {
    size: "sm",
    class: "py-64"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkStack), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NkForm), {
            ref_key: "form",
            ref: form,
            rules: _unref(rules),
            fields: fields
          }, {
            header: _withCtx(() => [
              _withDirectives(_createVNode(_component_ElAlert, { type: "error" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(error)), 1)
                ]),
                _: 1
              }, 512), [
                [_vShow, _unref(isError)]
              ]),
              _createVNode(_unref(NkCenter), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkHeading), {
                    type: "small-bold",
                    center: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('user.form.label.reset_your_password')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
                icon: "NkLogin",
                onClick: handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.submit')), 1)
                ]),
                _: 1
              })), [
                [_directive_loading, _unref(isLoading)]
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_unref(NkPasswordError), {
                  password: fields.password
                }, null, 8, ["password"]),
                _createVNode(_unref(NkFormItem), {
                  label: _ctx.$t('user.form.label.password'),
                  prop: "password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NkInputText), {
                      type: "password",
                      name: "password",
                      modelValue: fields.password,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.password) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode(_unref(NkFormItem), {
                label: _ctx.$t('user.form.label.repeated_password'),
                prop: "passwordConfirmation"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkInputText), {
                    type: "password",
                    name: "passwordConfirmation",
                    modelValue: fields.passwordConfirmation,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.passwordConfirmation) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["rules", "fields"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})